/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
// import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { useMutation, useQuery } from '@apollo/client';
import { Container, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Spacer from '@atoms/Spacer';
import Typography from '@atoms/Typography';
import OpportunitySeo from '@molecules/SEO/OpportunitySeo';

import Footer from '@organisms/common/Footer';
import FeaturedSlider from '@organisms/common/FeaturedSlider';
import OpportunityDetailsTemplate from '@templates/OpportunityDetails';
import ViewOpportunity from '@organisms/opportunities/ViewOpportunity';
import Skeleton from '@mui/lab/Skeleton';

import {
  SEARCH_OPPORTUNITY,
  VIEW_OPPORTUNITY,
  // GET_ORGANISATION_DETAILS,
} from '@app/apollo/queries';
import { useTranslation } from '@app/config/i18n';
import { deviceSizes } from '@app/config/devices';
import { addApolloState, initializeApollorWithQueries } from '@app/config/apollo';
import { TRACK_OPPORTUNITY_VIEWS } from '@app/apollo/mutations';
import { OPP_STATUS_ENUM } from '@app/constants';
import HeaderSidebar1Col from '@app/components/templates/HeaderSidebar1Col';


const OpportunityContainer = styled.div`
  background-color: ${({ theme }) => theme.secondaryColor[200]};
  padding: 4rem;
  h5 {
    padding: 0 0 1rem 0.5rem;
  }
  @media (max-width: ${deviceSizes.tablet}) {
    padding: 1rem;
    h5 {
      padding: 2rem 0 2rem 1rem;
    }
  }
`;

export const useClasses = makeStyles({
  CardContanerStyle: {
    paddingLeft: '1rem ',
    paddingRight: '1rem',
    paddingBottom: '0.5rem',
    height: '100%',
    [`@media only screen and (min-width: ${deviceSizes.mobileL}) and (max-width: 550px})`]: {
      paddingLeft: '2rem',
      paddingRight: '2rem',
    },
  },
});

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 550 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 550, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const OpportunityViewPage = ({ opportunity }) => {
  const { t } = useTranslation('common');
  const isDraft = opportunity.is_draft || opportunity.opp_status === OPP_STATUS_ENUM.DRAFT;

  // const classes = useClasses()

  const router = useRouter();
  const { slug } = router.query;

  const [trackViewsMutation, { loading: trackViewsLoading, error: trackViewsError }] = 
    useMutation(TRACK_OPPORTUNITY_VIEWS);
      
  
    // Get user IP function (this is just a simplified example)
    const getUserIP = async () => {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    };
  
    useEffect(() => {
      // getUserIP();
      trackViewsMutation({
        variables: {
          slug,
          ip: 'userIP',
        },
      });
    }, []);


  const {
    data: { opportunitySearch: { data: opportunities = [] } = {} } = {},
    // loading: searchLoading,
  } = useQuery(SEARCH_OPPORTUNITY, {
    variables: {
      input: {
        upcoming: true,
        organisation: opportunity?.organisation?.slug,
        ignore_opportunities: [opportunity?.id],
      },
      first: 4,
    },
    // skip: opportunityLoading || !opportunity?.organisation?.slug,
  });


  return (
    <>
      {isDraft ? (
        <HeaderSidebar1Col>
          <Skeleton animation="wave" variant="rect" height={200} />
        </HeaderSidebar1Col>
      ):(
        <>
          {opportunity && <OpportunitySeo opportunity={opportunity} />}
          <OpportunityDetailsTemplate
            opportunity={opportunity}
            background={opportunity && opportunity.logo && opportunity.logo.path}
          >
            {opportunity && (
              <>
                <Container>
                  <Grid container justifyContent="center">
                    <Grid item lg={7} sm={10} md={9} xs={12}>
                      <ViewOpportunity
                        slug={slug}
                        opportunity={opportunity}
                        loading={false}
                      />
                    </Grid>
                    <Spacer height="2rem" />
                  </Grid>
                </Container>
                <Spacer height="4rem" />
                {opportunities.length > 0 && (
                  <OpportunityContainer>
                    <Grid container justify="center" alignItems="center">
                      <Grid item lg={9} md={9} xs={12} sm={12}>
                        <Typography variant="h5">{t('similar_organiser')}</Typography>
                        <FeaturedSlider opportunities={opportunities} responsivnes={responsive} />
                      </Grid>
                    </Grid>
                  </OpportunityContainer>
                )}
                <Footer />
              </>
            )}
          </OpportunityDetailsTemplate>
        </>
      )}
    </>
  );
};

export async function getServerSideProps(ctx) {
  const { slug } = ctx.query;

  const {
    apolloClient,
    data: [{ opportunity } = {}],
  } = await initializeApollorWithQueries(ctx, [
    {
      query: VIEW_OPPORTUNITY,
      variables: {
        slug,
      },
    },
  ]);


  return addApolloState(apolloClient, {
    props: {
      opportunity,
      namespacesRequired: ['common', 'dashboard', 'wizard', 'applications'],
    },
    notFound: !opportunity,
  });
}

export default OpportunityViewPage;
